(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  const burger = $('.header-burger')
  const mobileMenu = $('.mobilemenu')

  function openMobileMenu() {
    const isActive = mobileMenu.hasClass('mobilemenu--active')

    if (isActive) {
      burger.removeClass('header-burger--active')
      mobileMenu.removeClass('mobilemenu--active')
    } else {
      burger.addClass('header-burger--active')
      mobileMenu.addClass('mobilemenu--active')
    }
    return false
  }

  burger.click(openMobileMenu)
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_mobile-menu.js","/")